import { createAsyncRequestTypes } from 'utils'

export const SEARCH = '@@SEARCH@@/'

export const SCREEN_DROP_DOWN_OPEN = createAsyncRequestTypes(
  `${SEARCH}SCREEN_DROP_DOWN_OPEN`
)
